import React from 'react';

const Dashboard = () => (

  <div class="bg-gradient-to-b from-blue-600 via-indigo-600 to-pink-600 min-h-screen flex flex-col items-center justify-center w-full">
  <div class="bg-white bg-opacity-90 p-10 rounded-2xl shadow-2xl max-w-4xl mx-4">
    <h1 class="text-5xl font-semibold text-center text-gray-900 mb-6">Welcome to the RBAC Management System</h1>
    <p class="text-center text-xl font-serif text-gray-700 leading-relaxed">
      VRV Security, founded in 2020 in Chennai, Tamil Nadu, is a global powerhouse in AI-driven cybersecurity solutions. With a presence in over 12 countries, we have rapidly expanded to protect digital assets for Fortune 500 companies and government organizations. In 2024, our company valuation soared to $400 million, and we continue to set new benchmarks in cybersecurity. We deliver more than 500,000 hours of proactive threat monitoring annually and have secured over 1 million endpoints worldwide. Trusted by over 200 international clients across 5 continents, our expert team ensures unparalleled security and client satisfaction.
    </p>
  </div>
</div>

);

export default Dashboard;
